import { Card, Grid, IconButton, styled } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";

export const CardContainer = styled(MDBox)`
  border-radius: 12px;
  position: relative;
  background-color: white;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const GridImageContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  height: 250px;
`;

export const BoxContainer = styled(MDBox)`
  position: relative;
  transition: transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1);
  z-index: 2;
`;

export const DropboxContainer = styled(MDBox)`
  border: 1px solid #dee2e6 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0.5rem;
  min-height: 14rem;
  padding: 1rem;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

export const ImageBox = styled(MDBox)`
  position: relative;
  min-height: 4.5rem;
  min-width: 4.5rem;
  max-height: 4.5rem;
  max-width: 4.5rem;
  background-color: blue;
  margin: 0.5rem;
`;

export const RemoveIconButton = styled(IconButton)`
  position: absolute;
  top: -7px;
  right: -2px;
  color: white;
  background-color: black;
  margin: 0.5rem;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 300ms cubic-bezier(0.34, 1.61, 0.7, 1);
  font-size: 15px;

  &:hover {
    background-color: red;
  }
`;

export const ImageContainer = styled(MDBox)`
  position: relative;
  object-fit: cover;
  border-radius: 0.5rem;
  margin: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  border-radius: 10px;
  z-index: 10;
  box-shadow: none !important;

  height: 304.219px;
  width: 456.328px;

  &:hover .card-header {
    transform: translate3d(0, -60px, 0);
  }
`;

export const EmptyCard = styled(Card)`
  height: 250px;
  width: 100%;
  z-index: 60;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const DisplayButtons = styled(MDBox)`
  margin-bottom: -200px;
  display: flex;
  gap: 10px;
  z-index: 1;
  justify-content: center;
  width: 100%;
  text-align: center;
`;
